import { useRef } from 'react';
import { Box, Image, useOutsideClick } from '@podiumhq/design-system';

import { POWERED_BY_GOOGLE_SRC } from 'lib/googleAutocomplete';

import { googleAutocompleteResultsWrapperStyles } from './styles';

export const GoogleAutocompleteWrapper = ({
  children,
  hideResults,
  ...styleProps
}) => {
  const wrapperRef = useRef(null);

  useOutsideClick({
    ref: wrapperRef,
    handler: () => hideResults && hideResults(),
  });

  return (
    <Box
      ref={wrapperRef}
      {...googleAutocompleteResultsWrapperStyles}
      {...styleProps}
    >
      {children}

      <Image
        alt="powered by google logo"
        className="styles__PoweredByGoogle"
        padding="0 16px"
        src={POWERED_BY_GOOGLE_SRC}
      />

      <Box id="GooglePlacesServiceMap" display="none" />
    </Box>
  );
};
